export const examplesText = [
  'Une série suisse qui se passe à Bellinzone?',
  'Quelles sont les séries à suspense?',
  'Peux-tu me conseiller des programmes pour toute la famille?',
  'Des séries suisses à ne pas manquer?',
  'Quels sont les programmes qui font voyager?',
  'Une série sur les échecs',
  'Des documentaires sur le changement climatique?',
  'Donne une liste des 10 meilleures séries policières historiques',
  'Quelques séries ou films qui font peur?',
  'Que me recommandes-tu comme comédie?',
  'Un truc avec Vincent Kucholl?',
  'Liste quelques bonnes séries à suspense européennes',
  'Liste 5 bonnes séries de science-fiction?',
  'Un drame social se déroulant en Europe?',
  'Trois mini-séries à suspense sorties cette année',
  'Liste six séries de science-fiction',
  'Peux-tu me suggérer un documentaire intéressant?',
  "Y'a quoi comme séries avec l'acteur qui fait Mr Bean?",
  "Quels programmes parlent d'écologie?",
  'Liste 6 super séries nordiques?',
  'Liste les meilleures séries historiques suisses?',
  'Quelles sont les fictions avec des ados?',
  'Y a-t-il de bonnes séries avec un humour british?',
  'Des mini-séries éducatives sur le développement durable?',
  'Les séries françaises à suspense?',
  'Documentaires abordant des enjeux sociaux actuels?',
  'Une liste de bonnes séries sur RTS play',
  "Liste quelques séries qui se passent au sud de l'Europe",
  'Des fictions qui abordent les enjeux environnementaux?',
  "J'ai aimé Better Call Saul. Fais-moi trois propositions du genre stp.",
  '10 propositions pour me remonter le moral',
  "Des programmes pour sensibiliser les enfants à l'écologie?",
  'Il y a des séries avec Hugh Laurie?',
  'Trois séries comiques scandinaves stp',
  "J'ai adoré Fallen. As-tu trois suggestions similaires?",
  'Connais-tu des séries qui se passent dans un resto?',
  "Quelle pourrait être une des dix séries à voir dans sa vie?",
]
